import React from "react";
import { DisplayText, List, Stack } from "@shopify/polaris";

import constant from "lib/constant/constant";

const commonValidation = (price, description, priceType, cms) => {
  if (!description) {
    return cms("message.error.addDescriptionForOffer");
  }
  if (description.length > 255) {
    return cms("message.error.descriptionCharacter");
  }
  if (!priceType) {
    return cms("message.error.selectShippingOfferType");
  }
  if (priceType !== constant.FREE && !price) {
    return cms("message.error.providePriceType");
  }
  if (priceType !== constant.FREE && price < 0) {
    return cms("message.error.provideValidPrice");
  }
  return false;
};

const checkValidation = (shippingOffer, cms) => {
  const { shippingBandId, price, description, priceType, productQuantity, productPrice, orderValue } =
    shippingOffer || {};
  const isProductPrice = shippingOffer.condition === constant.PRODUCT_PRICE;
  const isProductQuantity = shippingOffer.condition === constant.PRODUCT_QUANTITY;
  const isOrderValue = shippingOffer.condition === constant.ORDER_VALUE;
  if (!shippingBandId) {
    return cms("message.error..selectShippingBand");
  }
  if (isProductQuantity && !(productQuantity && constant.CRITERIA in productQuantity && productQuantity.criteria)) {
    return cms("message.error.selectCriteriaQuantity");
  }
  if (isProductQuantity && !(productQuantity && constant.VALUE in productQuantity && productQuantity.value)) {
    return cms("message.error.enterValidQuantity");
  }
  if (isProductQuantity && productQuantity.value <= 0) {
    return cms("message.error.enterValidQuantity");
  }
  if (isProductPrice && !(productPrice && constant.CRITERIA in productPrice && productPrice.criteria)) {
    return cms("message.error.selectCriteriaProduct");
  }
  if (isProductPrice && !(productPrice && constant.VALUE in productPrice && productPrice.value)) {
    return cms("message.error.providePrice");
  }
  if (isProductPrice && productPrice.value <= 0) {
    return cms("message.error.enterValidPrice");
  }
  if (isOrderValue && !(orderValue && constant.CRITERIA in orderValue && orderValue.criteria)) {
    return cms("message.error.selectCriteriaOrder");
  }
  if (isOrderValue && !(orderValue && constant.VALUE in orderValue && orderValue.value)) {
    return cms("message.error.provideOrder");
  }
  if (isOrderValue && orderValue.value <= 0) {
    return cms("error.enterValidOrderAmount");
  }
  return commonValidation(price, description, priceType, cms) || false;
};

const destinationsShow = (destinations, shippingOffer, cms) => {
  const list = destinations.map((item) => {
    const { title, options = [] } = item;
    const selectedOptions = options.filter((option) => shippingOffer.destinationCodes.includes(option.value));
    if (!selectedOptions.length) {
      return null;
    }
    return (
      <List.Item key={`${item.title}${selectedOptions.length}`}>
        {title}
        <List type="bullet">
          {selectedOptions.map((option) => (
            <List.Item key={option.value}>{option.label}</List.Item>
          ))}
        </List>
      </List.Item>
    );
  });
  const destinationList = list.filter((item) => item);

  if (!destinationList.length) {
    return null;
  }
  return (
    <Stack>
      <Stack.Item>
        <DisplayText size={constant.SMALL}>
          {cms("modal.offer.add.section.destination.label.selectedDestinations")}
        </DisplayText>
      </Stack.Item>
      <Stack.Item>
        <List type={constant.TYPE}>{destinationList}</List>
      </Stack.Item>
    </Stack>
  );
};

export { checkValidation, destinationsShow, commonValidation };
